let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6od1x")).then(() => parcelRequire('dSM9b'));